import Vue from 'vue';
import VueRouter from 'vue-router';
import Utils from '@/js/common/utils';
import storage from "store";
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {browserFlag} from '@/utils/BrowserUtil'
// import {isAuthPage} from 'js/config/menu-config';

Vue.use(VueRouter);

const initRouter = () => {
  const routerParam = {
    mode: 'history',
    routes: [
      {
        path: '/login',
        name: 'login',
        meta: {title: '登录'},
        component: () => import('@/components/login/Login'),
      },
      {
        path: '/',
        name: 'idx',
        component: () => import('@/layouts/BasicLayout'),
        meta: {title: '首页'},
        redirect: '/index',
        children: [
          {
            path: '/index',
            name: 'index',
            component: () => import('@/views/index/index'),
            meta: {title: '首页', keepAlive: true}
          },
          {
            path: '/venue',
            name: 'venue',
            component: () => import('@/views/venue/index'),
            meta: {title: '场馆列表', keepAlive: true}
          },
          // {
          //   path: '/teachers',
          //   name: 'teachers',
          //   component: () => import('@/views/teachers/index'),
          //   meta: {title: '师资', keepAlive: true}
          // },
          {
            path: '/activity',
            name: 'activity',
            component: () => import('@/views/activity/index'),
            meta: {title: '活动', keepAlive: true}
          },
          {
            path: '/activity-pc',
            name: 'activity-pc',
            component: () => import('@/views/activity/index-pc'),
            meta: {title: '活动', keepAlive: true}
          },
          {
            path: '/activity/teacherList',
            name: 'activityTeacherList',
            component: () => import('@/views/activity/teacherList'),
            meta: {title: '教师列表'}
          },
          {
            path: '/activity/teacherList-pc',
            name: 'activityTeacherList-pc',
            component: () => import('@/views/activity/teacherList-pc'),
            meta: {title: '教师列表'}
          },
          {
            path: '/activity/studentList',
            name: 'activityStudentList',
            component: () => import('@/views/activity/studentList'),
            meta: {title: '学生列表'}
          },
          {
            path: '/activity/studentList-pc',
            name: 'activityStudentList-pc',
            component: () => import('@/views/activity/studentList-pc'),
            meta: {title: '学生列表'}
          },
          {
            path: '/activity/studentDetail',
            name: 'activityStudentDetail',
            component: () => import('@/views/activity/studentDetail'),
            meta: {title: '学生详情'}
          },
          {
            path: '/activity/studentDetail-pc',
            name: 'activityStudentDetail-pc',
            component: () => import('@/views/activity/studentDetail-pc'),
            meta: {title: '学生详情'}
          },
          {
            path: '/activity/teacherDetail',
            name: 'activityTeacherDetail',
            component: () => import('@/views/activity/teacherDetail'),
            meta: {title: '教师详情'}
          },
          {
            path: '/activity/teacherDetail-pc',
            name: 'activityTeacherDetail-pc',
            component: () => import('@/views/activity/teacherDetail-pc'),
            meta: {title: '教师详情'}
          },
          {
            path: '/my',
            name: 'my',
            component: () => import('@/views/my/index'),
            meta: {title: '我的', keepAlive: true}
          },
          {
            path: '/components/noticeIndex',
            name: 'noticeIndex',
            component: () => import('@/views/index/components/noticeIndex'),
            meta: {title: '公告列表'}
          },
          {
            path: '/components/noticeDetail',
            name: 'noticeIndex2',
            component: () => import('@/views/index/components/noticeDetail'),
            meta: {title: '公告详情'}
          },
          {
            path: '/my/information',
            name: 'information',
            component: () => import('@/views/my/components/information'),
            meta: {title: '个人信息'}
          },
          {
            path: '/my/information-pc',
            name: 'information-pc',
            component: () => import('@/views/my/components/information-pc'),
            meta: {title: '个人信息'}
          },
          {
            path: '/my/campusCard',
            name: 'myCard',
            component: () => import('@/views/my/components/myCard'),
            meta: {title: '我的校园卡'}
          },
          {
            path: '/my/orderHxScan',
            name: 'orderHxScan',
            component: () => import('@/views/my/components/OrderHxScan'),
            meta: {title: '订单核销扫描'}
          },
          {
            path: '/my/orderHx',
            name: 'orderHx',
            component: () => import('@/views/my/components/OrderHx'),
            meta: {title: '订单核销详情', hiddenTabbar: true}
          },
          {
            path: '/my/stockList',
            name: 'stockList',
            component: () => import('@/views/my/components/StockList'),
            meta: {title: '库存查询'}
          },
          {
            path: '/my/entrust',
            name: 'entrustList',
            component: () => import('@/views/my/components/entrust/index'),
            meta: {title: '寄托服务'}
          },
          {
            path: '/my/entrust/add',
            name: 'entrustAdd',
            component: () => import('@/views/my/components/entrust/detail'),
            meta: {title: '寄托服务添加'}
          },
          {
            path: '/my/entrust/detail',
            name: 'entrustDetail',
            component: () => import('@/views/my/components/entrust/detail'),
            meta: {title: '寄托服务详情'}
          },
          // 订单相关路由
          {
            path: '/order/index',
            name: 'orderIndex',
            component: () => import('@/views/order/index'),
            meta: {title: '预约列表', hiddenTabbar: true}
          },
          {
            path: '/order/evaluate',
            name: 'evaluate',
            component: () => import('@/views/order/evaluate'),
            meta: {title: '评价', hiddenTabbar: true}
          },
          {
            path: '/order/detail',
            name: 'orderDetail',
            component: () => import('@/views/order/detail'),
            meta: {title: '预约详情', hiddenTabbar: true}
          },
          // 场馆相关路由
          {
            path: '/venue/detail',
            name: 'venueDetail',
            component: () => import('@/views/venue/detail'),
            meta: {title: '场馆简介', hiddenTabbar: false}
          },
          {
            path: '/venue/reserve',
            name: 'venueReserve',
            component: () => import('@/views/venue/reserve'),
            meta: {title: '场馆预约', hiddenTabbar: true}
          },
          {
            path: '/educationalTraining-pc',
            name: 'educationalTraining-pc',
            component: () => import('@/views/educationalTraining/index'),
            meta: {title: '教育培训', keepAlive: true, hiddenTabbar: true}
          },
          {
            path: '/educationalTraining-h5',
            name: 'educationalTraining-h5',
            component: () => import('@/views/educationalTraining-h5/index'),
            meta: {title: '教育培训', keepAlive: true, hiddenTabbar: true}
          },

          {
            path: '/venueDetail-pc',
            name: 'venueDetail-pc',
            component: () => import('@/views/venue/detail-pc'),
            meta: {title: '场馆简介', hiddenTabbar: true}
          },
          {
            path: '/venueReserve-pc',
            name: 'venueReserve-pc',
            component: () => import('@/views/venue/reserve-pc'),
            meta: {title: '场馆预约', hiddenTabbar: true}
          },
          {
            path: '/orderDetail-pc',
            name: 'orderDetail-pc',
            component: () => import('@/views/order/detail-pc'),
            meta: {title: '预约详情', hiddenTabbar: true}
          },
          {
            path: '/orderIndex-pc',
            name: 'orderIndex-pc',
            component: () => import('@/views/order/index-pc'),
            meta: {title: '预约列表', hiddenTabbar: true}
          },
          // 教师详情简介路由
          // {
          //   path: '/teacher/detail',
          //   name: 'teacherDetail',
          //   component: () => import('@/views/teachers/teacherDetail'),
          //   meta: {title: '教师详情', hiddenTabbar: true}
          // },
          // 教师评价路由comment
          {
            path: '/teacher/comment',
            name: 'teacherComment',
            component: () => import('@/views/teachers/comment'),
            meta: {title: '教师评价', hiddenTabbar: true}
          }
        ]
      }
    ]
  };

  let router = new VueRouter(routerParam);
  // let isFirstRouter = true;

  router.beforeEach((to, from, next) => {
    // if (!isFirstRouter && !isAuthPage(to.name)) {
    //     next({name: 'PermissionError'});
    //     return;
    // }
    if (to.path === '/tripDetail') {
      document.title = to.query.title
    } else if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    } else {
      document.title = '交大资源';
    }

    if (storage.get(ACCESS_TOKEN)) {
      if (to.path === '/login') {
        if (browserFlag()) {
          if (to.query.type  && to.query.type  === '1'){
            next({ path: '/educationalTraining-h5' })
          }else {
            next({ path: '/' })
          }
        } else {
          if (to.query.type  && to.query.type  === '1'){
            next({ path: '/educationalTraining-pc' })
          }else    if (to.query.type  && to.query.type  === '2'){
            next({ path: '/venueDetailPc' })
          }else {
            next({ path: '/activity' })
          }
        }
      } else {
        if (to.path === '/activity' && !browserFlag()) {
          next({ path: '/activity-pc' })
        }else  if (to.path === '/venueDetailPc' && !browserFlag()) {
          next({ path: '/venueDetail-pc' })
        }
      }
    }
    if (to.path == '/login' && to.query.type == '2'){
      router.replace({path:'/', query: {type: 2}})
    }
    if (to.path == '/404') {
      next();
      return;
    }
    //判断是否登录
    let currentUserToken = Utils.getLocal("currentUserToken");
    if (!currentUserToken || currentUserToken == 'undefined') {
      currentUserToken = to.query.currentUserToken;
    }
    if (!currentUserToken || currentUserToken == 'undefined') {
      // window.top.location = '/404'
    }



    next();
  });
  // router.afterEach(() => {
  //     document.documentElement.scrollTop = 0;
  //     document.body.scrollTop = 0;
  //     let layoutContent = document.querySelector('.h-layout-content');
  //     if (layoutContent) {
  //         layoutContent.scrollTop = 0;
  //     }
  // });
  return router;
};

export default initRouter;
